import { ChangeDetectorRef, Component, computed } from '@angular/core';
import { UsdmService } from '../../../services/ai/usdm.service';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-usdm',
  imports: [ AccordionModule ],
  templateUrl: './usdm.component.html',
  styleUrl: './usdm.component.css'
})
export class UsdmComponent {
  stateNameDict: { [key: string]: string } = {
    "start": "Start",
    "done": "Finish",
    "CreateStudy": "Create Study in OSB",
    "HighLevelDesign": "Study Properties",
    "Arm": "Treatment Arms",
    "Population": "Study Population",
    "Debug": "Debug",
    "Debug2": "Debug 2",
    "Debug3": "Debug 3",
    "Objectives": "Study Objectives",
    "Endpoints": "Study Endpoints",
    "StudyElement": "Study Elements",
    "Criteria": "Inclusion/Exclusion Criteria",
    "SOA": "Schedule of Activities Tables",
    "EpochVisit": "Study Epochs & Visits",
    "Activities": "Study Activities",
    "ScheduleOfActivities": "Schedule of Activities",
    "DownloadUsdm": "Create USDM JSON"
  }

  constructor(private usdmService: UsdmService, private cdr: ChangeDetectorRef) { }

  // Computed property to get the name of the currently running state
  currentRunningState = computed((): string => {
    const status = this.usdmStatus();
    const runningState = status.find(state => state.status === 'current');
    return runningState ? runningState.name : '';
  });

  usdmStatus = computed(() => {
    if (this.usdmService.workflowStatus()) {
      const states = this.usdmService.getStatesToRun();
      const internalUsdmStatus = this.usdmService.workflowStatus();
      // console.log("USDM Status:", internalUsdmStatus);
      const usdmStatus = [];
      // if (internalUsdmStatus && 'CreateStudy' in internalUsdmStatus) {
      //   states.unshift('CreateStudy');
      // }
      for (const sname of states) {
        const entry = internalUsdmStatus[sname] || { updates: [], status: 'pending' as const };
        usdmStatus.push({
          name: this.stateNameDict[sname],
          updates: entry.updates,
          status: entry.status
        });
      }
      return usdmStatus;
    } else {
      return [];
    }
  });
}
